/**
 * Customer-facing wording for enrollment status. Backend enums (SUBMITTED, MANUAL_FOLLOWUP, ...) never reach the
 * screen. The API answers with a PROGRESS KEY (backend/enroll/state_machine.py PROGRESS_KEY), not the internal state,
 * so this table is keyed by those values (QA-26). A submit response can only ever say "received"; "confirmed"
 * wording exists for a later status read and is only used when the server reports a positively confirmed status
 * (blueprint 3.1, fail-closed).
 */
export const PROGRESS_KEYS = ["received", "processing", "in_review", "supplier_confirmed", "active", "not_completed"];

const COPY = {
  received: "We received your request.",
  processing: "We received your request and are sending it to the provider.",
  in_review: "We received your request. Our team will follow up with you and the provider.",
  supplier_confirmed: "The provider has confirmed your request.",
  active: "Your enrollment is confirmed.",
  not_completed: "We could not complete your enrollment. Nothing was changed with your current provider.",
};

const DEFAULT_COPY = "We received your request.";

export function describeStatus(status) {
  return COPY[status] || DEFAULT_COPY;
}
